module.exports = __webpack_public_path__ + "static/media/Velai.04911f22.png";